import React, { createContext, useContext, useState, ReactNode } from "react";
import { KitchenInterface } from "../assets/interfaces/FX_POS_Interfaces";

interface KitchenContextType {
  selectedKitchen: KitchenInterface | null;
  setSelectedKitchen: (k: KitchenInterface | null) => void;
}

const KitchenContext = createContext<KitchenContextType | undefined>(undefined);

export const useKitchen = () => {
  const ctx = useContext(KitchenContext);
  if (!ctx) throw new Error("useKitchen must be used within KitchenProvider");
  return ctx;
};

export const KitchenProvider = ({ children }: { children: ReactNode }) => {
  const [selectedKitchen, setSelectedKitchen] = useState<KitchenInterface | null>(null);

  return (
    <KitchenContext.Provider value={{ selectedKitchen, setSelectedKitchen }}>
      {children}
    </KitchenContext.Provider>
  );
};
